import { Categoria } from './Categoria';

export class Producto {
    constructor(id, codigo, rowsPorProducto) {
        let me = this;

        this.id = id;
        this.codigo = codigo;
        this.categorias = [];

        rowsPorProducto.forEach(function (item) {
            let rowsPorCategoria = rowsPorProducto.filter(
                x => x.CategoriaId === item.CategoriaId
            );

            let index = me.categorias.findIndex(x => x.id === item.CategoriaId);
            if (index === -1) {
                me.categorias.push(new Categoria(item.CategoriaId, item.CategoriaCodigo, item.CategoriaDescripcion, rowsPorCategoria));
            }
        });
    }
}



// WEBPACK FOOTER //
// ./Portico/App/Common/Producto.js